import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { UserSessionService } from 'bna-angular-auth-client';
import { filter, of, Subscription, switchMap } from 'rxjs';
import { ClientSettingsService } from 'src/app/core/services/auth/client-settings.service';
import { OrganizationService } from 'src/app/core/services/http/agency-mgmt/organization.service';
import { AppSettings } from 'src/app/shared/constants/app-settings.constants';
import { SwitchOrganizationComponent } from '../switch-oganization/switch-oganization.component';

@Component({
  selector: 'app-switch-organization-popup',
  templateUrl: './switch-organization-popup.component.html',
})
export class SwitchOrganizationPopupComponent implements OnInit, OnDestroy {
  private sub: Subscription;
  private enabled = false;

  constructor(
    public dialog: MatDialog,
    private userSessionService: UserSessionService,
    private organizationService: OrganizationService,
    private clientSettingsService: ClientSettingsService
  ) {}

  ngOnInit() {
    this.enabled = !this.userSessionService.isIntegration;
    this.sub = this.userSessionService.isAuthenticated$.subscribe((result) => {
      if (!this.enabled || !result.isAuthenticated) return;

      this.organizationService
        .getList()
        .pipe(
          filter(
            (organizations) => organizations != null && organizations.length > 1
          ),
          switchMap((d) => of(d))
        )
        .subscribe(() => this.openDialog());
    });
  }

  ngOnDestroy() {
    this.sub.unsubscribe();
  }

  openDialog() {
    if (this.isOpened) return;

    this.markAsOpened();
    const dialogRef = this.dialog.open(SwitchOrganizationComponent, {
      maxWidth: '100vw',
      maxHeight: '100vh',
      height: '80%',
      width: '80%',
      data: { modalPopup: true },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((result) => {
      console.log(`Dialog result: ${result}`);
    });
  }

  private markAsOpened() {
    this.clientSettingsService.set(
      AppSettings.AgencySelectionPopedUp,
      true,
      false
    );
  }

  private get isOpened() {
    return Boolean(
      this.clientSettingsService.get(AppSettings.AgencySelectionPopedUp, false)
    );
  }
}
